<div class="pt-3" *ngIf="eventTypeNotFound">
  <h2>Event not found</h2>
</div>

<div class="pt-3" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3 pl-md-4 mb-6" *ngIf="!eventTypeNotFound && (serverError === null)">
  <div class="row">
    <div class="col">
      <p class="mt-2" style="width:100%;text-align:center">
        <span *ngIf="eventType === null">LOADING EVENT...</span>
        <span *ngIf="eventType !== null">EDIT EVENT: {{ eventType.name }}</span>
      </p>
    </div>
  </div>

  <div class="mb-3 border-rounded-10">

    <app-event-setup-nav [loadingEventType]="loadingEventType" [eventType]="eventType"></app-event-setup-nav>

    <div class="m-4" *ngIf="loadingEventType || loadingPricingMatrices">
      <h3 class="text-muted">Loading...</h3>
    </div>

    <app-event-type-edit-schedule-repeating
      [eventType]="eventType"
      [pricingMatrices]="pricingMatrices"
      [locations]="getAllowedLocations()"
      *ngIf="eventType && (eventType.schedule_type !== ScheduleType.oneOff) && (pricingMatrices !== null)">
    </app-event-type-edit-schedule-repeating>

    <app-event-type-edit-schedule-non-repeating
      [eventType]="eventType"
      [pricingMatrices]="pricingMatrices"
      [locations]="getAllowedLocations()"
      *ngIf="eventType && (eventType.schedule_type === ScheduleType.oneOff) && (pricingMatrices !== null)">
    </app-event-type-edit-schedule-non-repeating>

  </div>

</div>
